import * as criteoHotels from './criteo/criteoHotels'

function ensureDataLayerIsDefined () {
  /* eslint-disable-next-line */
  window.criteo_q = window.criteo_q || []
}

export function init () {
  ensureDataLayerIsDefined()

  criteoHotels.init()
}



// WEBPACK FOOTER //
// ./src/modules/criteo.js